











import { Vue, Prop, Component } from "vue-property-decorator";
import IconBase from "@/common/components/atoms/IconBase.vue";
import DecorationSpeechBubbleLeftPc from "@/common/components/atoms/DecorationSpeechBubbleLeftPc.vue";
import DecorationSpeechBubbleLeftSp from "@/common/components/atoms/DecorationSpeechBubbleLeftSp.vue";
import DecorationSpeechBubbleRightPc from "@/common/components/atoms/DecorationSpeechBubbleRightPc.vue";
import DecorationSpeechBubbleRightSp from "@/common/components/atoms/DecorationSpeechBubbleRightSp.vue";

@Component({
  components: {
    IconBase,

    DecorationSpeechBubbleLeftPc,
    DecorationSpeechBubbleLeftSp,
    DecorationSpeechBubbleRightPc,
    DecorationSpeechBubbleRightSp
  }
})
export default class DecorationSpeechBubble extends Vue {
  @Prop({ type: String, default: "left" }) direction!: string;
  @Prop({ type: String, default: "pc" }) terminal!: string;
  iconSizeObject: {
    sp: {
      width: number;
      height: number;
    };
    pc: {
      width: number;
      height: number;
    };
  } = {
    sp: {
      width: 11,
      height: 8
    },
    
    pc: {
      width: 16,
      height: 12
    }
  };

  iconColor: any = {
    left: "#ffffff",
    right: "#e0e0e0"
  };

  get iconComponent() {
    return `decoration-speech-bubble-${this.direction}-${this.terminal}`;
  }

  get currentIconSize() {
    const isSp: number = this.$store.state.isSpScreenWidth;
    return isSp ? this.iconSizeObject["sp"] : this.iconSizeObject["pc"];
  }

  get currentIconColor() {
    return this.iconColor[this.direction];
  }
}
